import { render } from "./BlockSocioDados.vue?vue&type=template&id=25d71aff"
import script from "./BlockSocioDados.vue?vue&type=script&lang=js"
export * from "./BlockSocioDados.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CampoForm/components/BlockSocioDados.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25d71aff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25d71aff', __exports__)) {
    console.log('reload')
    api.reload('25d71aff', __exports__)
  }
  
  module.hot.accept("./BlockSocioDados.vue?vue&type=template&id=25d71aff", () => {
    console.log('re-render')
    api.rerender('25d71aff', render)
  })

}


export default __exports__